"use client";

import React from "react";
import { Button } from "../../ui/button";
import { ArrowLeft } from "lucide-react";
import COMCIPETesting from "./COMCIPETesting";
import COMCExceptionTesting from "./COMCExceptionTesting";
import COMCPredictiveAnalytics from "./COMCPredictiveAnalytics";

interface COMCSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  procedureId?: string;
}

// Map procedureId to section name
const getSectionName = (procedureId?: string): string | null => {
  if (!procedureId) return null;
  const mapping: Record<string, string> = {
    "ipe-testing": "IPE Testing",
    "exception-testing": "Exception Testing",
    "test-of-details": "Test of Details",
    "analytical-procedures": "Analytical Procedures",
  };
  return mapping[procedureId] || null;
};

export default function COMCSubstantive({ onBack, setActiveSection, procedureId }: COMCSubstantiveProps) {
  const handleBack = () => {
    if (setActiveSection) {
      setActiveSection("comc-substantive");
    } else if (onBack) {
      onBack();
    }
  };

  if (procedureId === "predictive-analytics") {
    return <COMCPredictiveAnalytics onBack={handleBack} />;
  }

  const currentSectionName = getSectionName(procedureId);

  // If no procedureId or invalid procedureId, show nothing (should be handled by routing)
  if (!procedureId || !currentSectionName) {
    return null;
  }

  // Render the appropriate component based on procedureId
  if (procedureId === "ipe-testing") {
    return <COMCIPETesting onBack={handleBack} />;
  }

  if (procedureId === "exception-testing") {
    return <COMCExceptionTesting onBack={handleBack} />;
  }

  // For Test of Details and Analytical Procedures, show placeholder content
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white">{currentSectionName}</h2>
          <p className="text-gray-400">Content to be added</p>
        </div>
        <Button variant="outline" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
      </div>
      <div className="rounded-lg border border-white/10 bg-white/5 p-8 text-center text-white/60">
        <p>Content for {currentSectionName} will be added here.</p>
      </div>
    </div>
  );
}


